import { FastifyRequest } from 'fastify';
import { BASE_URL } from 'helpers/global.const.helper';

export const generateAddOpinionLink = (url: string): string => `${url?.replace('opinie', 'ocen')}?utm_source=skapiec&#zawartosc`;

export const isFrontPage = (url?: string): boolean => {
    return ((url === '') || (url === '/'));
};

export const isFullUrl = (url = ''): boolean => {
    if (!url) {
        return false;
    }

    return url.startsWith('http');
};

export const getUrl = (req: FastifyRequest, path: string): string => {
    return `${req.protocol}://${req.hostname}${path}`;
};

export const normalizeUrl = (url = ''): string => {
    return !url ? '' : `/${url.replace(/^\//, '')}`;
};

export const isEncodedURI = (value: string): boolean => {
    try {
        return value !== decodeURI(value);
    } catch {
        return false;
    }
};

export const normalizeRedirectUrl = (req: FastifyRequest, redirectUrl: string): string => {
    const url = isFullUrl(redirectUrl) ? redirectUrl : getUrl(req, normalizeUrl(redirectUrl));

    if (!isEncodedURI(url)) {
        return encodeURI(url);
    } else {
        return url;
    }
};

export const getFullUrl = (url = ''): string => {
    return isFullUrl(url) ? url : `${BASE_URL}${normalizeUrl(url)}`;
};

export const safeQueryParam = (query: Record<string, string>, param: string): string | null => {
    for (const paramKey in query) {
        if (paramKey.toLowerCase() === param.toLowerCase()) {
            return query[paramKey].replace(/[^a-zA-Z0-9\-_+]/g, '');
        }
    }

    return null;
};
